module.exports = __webpack_public_path__ + "static/media/unlink.e8d5701f.svg";